import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function TrustInsuranceLicensesAnjouan() {

    return (
        <main className='main'>

            <IntroSection
                title="Insurance & Reinsurance License – Anjouan (Comoros)"
                subtitle="Affordable Offshore Insurance Structures with AOFA Licensing"
                description="<b>Anjouan</b>, part of the <b>Union of Comoros</b>, has emerged as a <b>popular jurisdiction</b> for <b>Insurance and Reinsurance Licenses</b> under the <b>Anjouan Offshore Finance Authority (AOFA)</b>. With <b>no capital requirements</b>, <b>low setup costs</b>, and <b>fast approvals</b>, it is an excellent choice for <b>entrepreneurs</b>, <b>risk managers</b>, and <b>corporations</b> seeking <b>captive insurance</b>, <b>reinsurance</b>, or <b>niche coverage solutions</b>."
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Reinsurance",
                        "Specialty/Niche Insurance"
                    ]
                }
                buttonText="Request an Anjouan Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/trust-insurance-licenses-anjouan-hero.jpg")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Anjouan?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "No Capital Requirement",
                                                text: "Unlike Bermuda, Malta, or Cayman."
                                            },
                                            {
                                                title: "Fast Approvals",
                                                text: "Licenses issued in 4–8 weeks."
                                            },
                                            {
                                                title: "Cost-Effective",
                                                text: "Significantly lower setup & renewal costs than Tier-1 insurance hubs."
                                            },
                                            {
                                                title: "Operate Internationally",
                                                text: "AOFA licenses are designed for global markets."
                                            },
                                            {
                                                title: "Flexible Framework",
                                                text: "Ideal for niche insurance (crypto, fintech, high-risk sectors)."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="What the License Covers"
                        blocks={
                            [
                                {
                                    title: "Insurance License",
                                    items:
                                        [
                                            {
                                                text: "Life, health, property & casualty insurance"
                                            },
                                            {
                                                text: "Captive insurance for corporations & HNWIs"
                                            },
                                            {
                                                text: "Niche insurance for fintech, crypto, and specialized industries"
                                            },
                                            {
                                                text: "Underwriting & risk management"
                                            }
                                        ],

                                },
                                {
                                    title: "Reinsurance License",
                                    items: [
                                        {
                                            text: "Reinsurance services for global insurers"
                                        },
                                        {
                                            text: "Alternative risk transfer solutions"
                                        },
                                        {
                                            text: "Support for captive & mutual reinsurance pools"
                                        },
                                        {
                                            text: "Multi-jurisdictional reinsurance coverage"
                                        }
                                    ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Benefits of an Anjouan Insurance License"
                        item={
                            [
                                {
                                    title: "Global Flexibility",
                                    text: "Operate in international markets."
                                },
                                {
                                    title: "Affordable",
                                    text: "Much cheaper than Malta, Gibraltar, or Bermuda."
                                },
                                {
                                    title: "No Capital Requirement",
                                    text: "Easy entry for startups & new insurers."
                                },
                                {
                                    title: "Banking & PSP Access",
                                    text: "Offshore Advisory provides EMI/PSP introductions."
                                },
                                {
                                    title: "Scalable",
                                    text: "Start with captive, expand into general insurance or reinsurance."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Define insurance or reinsurance model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Set up an International Business Company (IBC) in Anjouan."
                                },
                                {
                                    title: "Compliance Documentation",
                                    text: "AML/KYC, risk framework, actuarial plan."
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits to AOFA."
                                },
                                {
                                    title: "Approval & License Issuance",
                                    text: "Typically within 4–8 weeks."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "4–8 weeks.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 19,000–20,000+."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "None"
                                },
                                {
                                    name: "Annual Costs",
                                    description: "lower than Seychelles, Belize, or Mauritius."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Authorized AOFA agent with insurance & reinsurance expertise."
                                },
                                {
                                    text: "End-to-end support: incorporation, license filing, compliance manuals."
                                },
                                {
                                    text: "Access to actuarial consultants, captive managers, and reinsurance networks."
                                },
                                {
                                    text: "Guidance on banking, PSPs, and insurance software integration."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish an insurance or reinsurance company?"
                        description="Anjouan offers fast, affordable licensing with no capital requirements — ideal for captives, reinsurers, and niche insurers."
                        buttonText="Book an Anjouan Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement for insurance/reinsurance in Anjouan?",
        content: [
            { type: "answer", text: "No — AOFA has no minimum capital requirements, unlike most other regulators." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Usually 4–8 weeks, one of the fastest worldwide." },
        ],
    },
    {
        question: "Can I operate captive insurance structures?",
        content: [
            { type: "answer", text: "Yes — captives are one of the most common insurance models under AOFA." },
        ],
    },
    {
        question: "Is reinsurance supported?",
        content: [
            { type: "answer", text: "Yes — you can license a reinsurance company to operate internationally." },
        ],
    },
    {
        question: "Can niche/crypto insurance models be licensed?",
        content: [
            { type: "answer", text: "Yes — AOFA is flexible and accepts innovative business models like crypto or fintech insurance." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We licensed our captive insurance company in Anjouan with Offshore Advisory. Fast approval and simple compliance.",
        author: "Daniel R.",
        role: "Corporate Risk Manager"
    },
    {
        quote: "Our reinsurance setup in Anjouan was completed in 6 weeks. Offshore Advisory handled compliance and actuarial support.",
        author: "Sofia M.",
        role: "Reinsurance Director"
    }
];